import React, { Component } from 'react';

import Title from '../../components/Title';
import Conteudo from '../../Conteudo';

import ListaMudancas from './ListaMudancas';

export default class extends Component {
  render() {
    return (<div>
        <Title value="Diego Rivera » Mudanças" />
        <Conteudo>
          <ListaMudancas />
        </Conteudo>
    </div>);
  }
}


// WEBPACK FOOTER //
// ./src/modules/mudancas/Index.js